module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Light.b9298ce4.ttf";